import script from "./ActionMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActionMenu.vue?vue&type=script&lang=ts&setup=true"

import "./ActionMenu.vue?vue&type=style&index=0&id=5e80942a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e80942a"]])

export default __exports__